import { defineNuxtPlugin } from "#app";

export default defineNuxtPlugin(() => {
  onMounted(() => {
    const fadeElements = document.querySelectorAll(".fade-in");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.2 } // Déclenche l’animation lorsque 20% de l’élément est visible
    );

    fadeElements.forEach((el) => observer.observe(el));
  });
});
